import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const EbuiltInfoCardStyles = styled.div`
  margin: 72px 0 0;
  background-color: ${Colors.primary.claytonBlue.light};
  margin: 0 auto;
  width: 100%;
  padding: 48px 24px;

  .ebuilt-info-container {
    .ebuilt-info-header-content {
      text-align: center;
      h3 {
        margin-bottom: 8px;
      }
      svg {
        margin-bottom: 12px;
      }
    }

    .control-box {
      height: 59px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      padding: 8px;
      margin: 12px auto 0;
      width: fit-content;
      p {
        color: ${Colors.primary.claytonBlue.standard};
      }
    }
    .chev {
      margin-left: 4px;
    }
    .up {
      transform: translate(5px, 3px);
    }

    .ebuilt-info-content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 48px;
      .efficiency-item {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: 12px 0px;
        width: 100%;
        border-bottom: 1px solid #cacccf;
        svg {
          width: 24px;
        }
      }
      .flex-end {
        justify-content: start;
      }
      .efficiency-text {
        margin-left: 16px;
        width: 100%;
        text-align: left;
        h4 {
          margin-bottom: 8px;
        }
        > p {
          line-height: 21px;
          font-size: 16px;
        }
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    margin: 96px 0 0;
    .ebuilt-info-container {
      .ebuilt-info-content {
        .efficiency-item {
          width: 50%;
          border: none;
        }
        .efficiency-text {
          width: 85%;
          h4 {
            line-height: 24px;
          }
        }
        .flex-end {
          justify-content: end;
        }
      }
    }
  }
`;
